import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from 'src/app/services/home/home.service';
import { ITransition } from './transition.interface';

@Component({
  selector: 'app-transition',
  templateUrl: './transition.component.html',
  styleUrls: ['./transition.component.scss'],
})
export class TransitionComponent implements OnInit {
  transitions: ITransition[] = [];
  engagementId?: string;
  visibleTransitions: ITransition[] = [];
  loading = false;
  constructor(
    private homeServiceRef: HomeService,
    private route: ActivatedRoute, private router: Router,
  ) {}
  setRAG(rag:String) : String{
    switch (rag){
      case 'OnTrack': return 'On Track'
      case 'AtRisk': return 'At Risk'
      case 'Delayed': return 'Delayed'
      default: return rag;
      break;
      }
  }
  ngOnInit(): void {
    this.loading = true;
    // const id = this.route.snapshot.paramMap.get('id');
    this.homeServiceRef.getEngagementId().subscribe(enagementId=>{
      this.engagementId = enagementId;
      this.loading = true;
      if (this.engagementId) {
        this.homeServiceRef.getTransitions(this.engagementId).subscribe((res) => {
          this.transitions = res;
          this.visibleTransitions = res.filter((e:ITransition)=> e.isDisplayed).map((e:ITransition)=> ({...e, rag:this.setRAG(e.rag)}));
          this.loading = false;
        });
      }
    });
  }
  goto(linkName:any, transition: ITransition){
    if(this.engagementId != "")
    {
      if(linkName == "Transition Page"){
        this.router.navigate([`/transition-page`, {id: this.engagementId, transitionId: transition.id}]);
      }
    }
  
  }
}
